import type {ColorSwatch} from '../color-swatch-picker/color-swatch-picker';
import type {ColorItem} from '../grid-selector/grid-selector';

import {colors} from './colors';
import type {ColorName} from './colors';

/**
 * Deprecated: Working to update the instances of these colors to the new darker tag colors
 * Mapping of tag color enum to ColorNames for the tag in order of how they will appear in
 * the color picker:
 * 0  1  2  3  4  5  6 (lighter shades above darker shades)
 * 7  8  9  10 11 12 13 (darker shades below lighter shades)
 *
 * @type {{[COLOR_ENUM]: ColorName}}
 */
export const TAG_COLOR_NAMES_MAP: {
    [key: string]: {
        colorName: ColorName;
    };
} = {
    // 0  1  2  3  4  5  6 (lighter shades above darker shades)
    COLOR_DEFAULT: {
        colorName: 'tagGreyLt',
    },
    COLOR_RED_LT: {
        colorName: 'tagRedLt',
    },
    COLOR_ORANGE_LT: {
        colorName: 'tagOrangeLt',
    },
    COLOR_YELLOW_LT: {
        colorName: 'tagYellowLt',
    },
    COLOR_GREEN_LT: {
        colorName: 'tagGreenLt',
    },
    COLOR_BLUE_LT: {
        colorName: 'tagBlueLt',
    },
    COLOR_PURPLE_LT: {
        colorName: 'tagPurpleLt',
    },
    // 7  8  9  10 11 12 13 (darker shades below lighter shades
    COLOR_GREY: {
        colorName: 'tagGrey',
    },
    COLOR_RED: {
        colorName: 'tagRed',
    },
    COLOR_ORANGE: {
        colorName: 'tagOrange',
    },
    COLOR_YELLOW: {
        colorName: 'tagYellow',
    },
    COLOR_GREEN: {
        colorName: 'tagGreen',
    },
    COLOR_BLUE: {
        colorName: 'tagBlue',
    },
    COLOR_PURPLE: {
        colorName: 'tagPurple',
    },
};

/**
 * Mapping of tag color enum to ColorNames for the new darker tag colors
 */
export const TAG_COLOR_NAMES_MAP_DARK: {
    [key: string]: {
        colorName: ColorName;
    };
} = {
    // 0  1  2  3  4  5  6 (lighter shades above darker shades)
    COLOR_DEFAULT: {
        colorName: 'tagGrey',
    },
    COLOR_RED_LT: {
        colorName: 'tagRed',
    },
    COLOR_ORANGE_LT: {
        colorName: 'tagOrange',
    },
    COLOR_YELLOW_LT: {
        colorName: 'tagYellow',
    },
    COLOR_GREEN_LT: {
        colorName: 'tagGreen',
    },
    COLOR_BLUE_LT: {
        colorName: 'tagBlue',
    },
    COLOR_PURPLE_LT: {
        colorName: 'tagPurple',
    },
    // 7  8  9  10 11 12 13 (darker shades below lighter shades
    COLOR_GREY: {
        colorName: 'tagGreyDk',
    },
    COLOR_RED: {
        colorName: 'tagRedDk',
    },
    COLOR_ORANGE: {
        colorName: 'tagOrangeDk',
    },
    COLOR_YELLOW: {
        colorName: 'tagYellowDk',
    },
    COLOR_GREEN: {
        colorName: 'tagGreenDk',
    },
    COLOR_BLUE: {
        colorName: 'tagBlueDk',
    },
    COLOR_PURPLE: {
        colorName: 'tagPurpleDk',
    },
};

// Deprecated: Working to update the instances of this function to use the new darker tag colors
export const getColorNameFromTagColor = (tagColor?: string | null): ColorName => {
    return (
        // @ts-expect-error
        (tagColor && TAG_COLOR_NAMES_MAP[tagColor].colorName) ||
        // @ts-expect-error
        TAG_COLOR_NAMES_MAP.COLOR_DEFAULT.colorName
    );
};

export const getColorNameFromTagColorDark = (tagColor?: string | null): ColorName => {
    return (
        // @ts-expect-error
        (tagColor && TAG_COLOR_NAMES_MAP_DARK[tagColor].colorName) ||
        // @ts-expect-error
        TAG_COLOR_NAMES_MAP_DARK.COLOR_DEFAULT.colorName
    );
};

export const getTagColorSwatches = (): ColorSwatch[] => {
    return Object.keys(TAG_COLOR_NAMES_MAP_DARK).map((tagColor: string) => ({
        id: tagColor,
        // @ts-expect-error
        colorName: TAG_COLOR_NAMES_MAP_DARK[tagColor].colorName,
    }));
};

export const getTagColorGridItems = (): ColorItem[] => {
    // @ts-expect-error
    return Object.keys(TAG_COLOR_NAMES_MAP_DARK).map((tagColor: string) => ({
        id: tagColor,
        type: 'color',
        // @ts-expect-error
        content: colors[TAG_COLOR_NAMES_MAP_DARK[tagColor].colorName] || colors.tagGrey,
    }));
};
